module.exports = __webpack_public_path__ + "img/expire_use_coupon.f21cc7b1.png";